<template>
  <div class="tFooter">
    <!-- 底部-->
    <div class="ibar ibar-tab flex flexa">
      <div class="itab-item" :class="{ iactive: bmTab == 1 }" @click="active(1)">
        <img class="ft-icon" v-if="bmTab == 1" src="../assets/img/tabs/1844.png" />
        <img class="ft-icon" v-if="bmTab != 1" src="../assets/img/tabs/h.png" />
        <span class="itab-label">首页</span>
      </div>
      <div class="itab-item" :class="{ iactive: bmTab == 2 }" @click="active(2)">
        <img class="ft-icon" v-if="bmTab == 2" src="../assets/img/tabs/1850.png" />
        <img class="ft-icon" v-if="bmTab != 2" src="../assets/img/tabs/c.png" />
        <span class="itab-label">爱窝</span>
      </div>
      <!-- <div class="itab-item" :class="{ iactive: bmTab == 3 }" @click="active(3)">
        <img class="ft-icon" v-if="bmTab == 3" src="../assets/img/tabs/lottery_tabbar_icon.jpeg" />
        <img class="ft-icon" v-if="bmTab != 3" src="../assets/img/tabs/lottery_tabbar_icon.jpeg" />
        <span class="itab-label">撞宝</span>
      </div> -->
      <div class="itab-item" :class="{ iactive: bmTab == 3 }" @click="active(3)">
        <img class="ft-icon" v-if="bmTab == 3" src="../assets/img/tabs/5481.png" />
        <img class="ft-icon" v-if="bmTab != 3" src="../assets/img/tabs/2.png" />
        <span class="itab-label">谈宝</span>
      </div>
      <div class="itab-item" :class="{ iactive: bmTab == 4 }" @click="active(4)">
        <img class="ft-icon" v-if="bmTab == 4" src="../assets/img/tabs/4.png" />
        <img class="ft-icon" v-if="bmTab != 4" src="../assets/img/tabs/i.png" />
        <span class="itab-label">印迹</span>
      </div>
      <div class="itab-item" :class="{ iactive: bmTab == 5 }" @click="active(5)">
        <img class="ft-icon" v-if="bmTab == 5" src="../assets/img/tabs/5.png" />
        <img class="ft-icon" v-if="bmTab != 5" src="../assets/img/tabs/p.png" />
        <span class="itab-label">我的</span>
      </div>
    </div>
  </div>
</template>

<script>
// import { Toast, Tabbar, TabItem } from "mint-ui";
import { mapActions } from 'vuex'
import api from '@/utils/api'
import { aPost } from '@/utils/request'

export default {
  name: 'tFooter',
  data() {
    return {
      // 店铺是否存在活动 0没有，1有
      whetherActivity: 0
    }
  },
  watch: {
    // $route(to, from) {
    //   //监听路由变化
    //   console.log('to.meta.index',to.meta.index)
    //   console.log('this.$store.state.bmTab',this.$store.state.bmTab)
    //   if (to.meta.index == 2 || to.meta.index == 10 || to.meta.index == 11) {
    //     this.$store.state.identify = 2;
    //   }
    //   if (
    //     to.meta.index == 1 ||
    //     to.meta.index == 3 ||
    //     to.meta.index == 5
    //   ) {
    //     this.$store.state.identify = 0;
    //   }
    //   if (to.meta.index == 4) {
    //     if (this.$store.state.identify == 1) {
    //       this.$store.state.bmTab = 11;
    //     }else{
    //       this.$store.state.bmTab = to.meta.index;
    //     }
    //   } else {
    //     this.$store.state.bmTab = to.meta.index;
    //   }
    //   // console.log(to);
    //   // console.log(this.$store.state.bmTab);
    //   console.log(this.$route.matched);
    // }
  },
  computed: {
    bmTab() {
      return this.$store.state.bmTab
    },
    id() {
      return this.$store.state.identify
    }
  },
  data() {
    return {}
  },
  // watch: {},
  methods: {
    ...mapActions(['setIsCart']),
    active(n) {
      let that = this
      this.$store.state.bmTab = n
      if (n == 1) {
        this.$router.replace({ path: '/' }).catch((err) => {})
        this.setIsCart(0)
      }
      if (n == 2) {
        this.$router.replace({ path: '/cart' }).catch((err) => {})
        this.setIsCart(0)
      }
      if (n == 3) {
        // this.$router.replace({ path: '/Lottery?storeId=' + this.$store.state.storeId }).catch((err) => {})
        this.$router.replace({ path: '/scan' }).catch((err) => {})
        this.setIsCart(0)
      }
      if (n == 4) {
        this.$router.replace({ path: '/imprint' }).catch((err) => {})
        this.setIsCart(1)
      }
      if (n == 5) {
        this.$router.replace({ path: '/mySliding' }).catch((err) => {})
        this.setIsCart(0)
      }
      /*console.log(" tab n", n);
      console.log(" tab id", this.id);
      console.log(" tab id", this.$store.state.bmTab);*/
    }
    // 查询店铺是否活动
    // getStoreActivity() {
    //   aPost(api.whetherActivity, { storeId: this.$store.state.storeId }).then((res) => {
    //     if (res.data.code === 0) {
    //       this.whetherActivity = res.data.whetherActivity
    //     }
    //   })
    // }
  },
  created() {
    // this.getStoreActivity()
    // console.log(" tab id", this.$store.state.bmTab);
  }
}
</script>

<style lang="scss">
.tFooter {
  position: fixed;
  bottom: 0;
  left: 0px;
  right: 0px;
  // margin-top: 0.3rem;
  background: #ffffff;
  height: 104px;
  box-shadow: 0px 0px 21px rgba(0, 0, 0, 0.04);
  //opacity: 1;
  z-index: 10;
  .ibar {
    background: #fff;
    .itab-item {
      //flex: 0 0 250px;
      flex: 0 0 calc(100% / 5);
      flex-direction: column;
      height: 100%;
      font-size: 20px;
      // font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 21px;
      color: #aeb2b8;
      text-align: center;
      img {
        width: 46px;
        height: 46px;
        margin: 13px auto 12px;
      }
    }
  }

  .iactive {
    font-size: 20px;
    // font-family: Source Han Sans CN;
    font-weight: 500 !important;
    line-height: 20px;
    color: #000000 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tfooter.vue